import styled from 'styled-components';
import { useRouter } from 'next/router';
import Button from '@base/Button/Button';
import { segment } from '@actions/analytics';
import { toggleLoginModal } from '@actions/auth';
import { LOGIN_STARTED } from '@constants/segment';
import cookies from '@utils/cookies';
import { useDispatch } from 'react-redux';
import { loginModalUrls } from '@constants/mobileUrls';
import useWindowSize from '@hooks/useWindowSize';

const StyledDiv = styled(Button)`
  grid-column: 23/25;
  align-self: center;
  display: flex;
  @media (max-width: 70.95em) {
    grid-column: 22/25;
    min-height: 32px;
    height: 32px;
  }
  @media (max-width: 47.95em) {
    color: #08bd80;
    background-color: transparent;
    height: 14px;
    width: auto;
    grid-column: 7/9;
    &:active {
      background-color: transparent;
      border: none;
      transform: none;
    }
  }
`;

const Actions = () => {
  const dispatch = useDispatch();
  const { isMobile } = useWindowSize();
  const { asPath, route } = useRouter();
  const showLoginModal = loginModalUrls.includes(route);
  const login = () => {
    segment.track(LOGIN_STARTED);
    if (isMobile && !showLoginModal) {
      cookies.setCookie('loginRoute', asPath);
      window.location.href = '/login';
    } else {
      dispatch(toggleLoginModal(true));
    }
  };

  return <StyledDiv label="Login" variant="filled" onClick={login} grid={2} />;
};

export default Actions;
